import React, { useState } from 'react'
import HoursItem from './HoursItem'
export default function HoursModal(props) {
  //finds the day object in the array.
  const dayObject = props.daysTimeBlocks.filter(obj => {
    return obj.day === props.editingDay
  })[0]

  return (
    <div className='hours-modal'>
      <div className='hours-item-header'>
        <h3>Editing Hours: {props.editingDay}</h3>
        <div className='hours-operation-btns'>
          <button className='btn btn-primary' onClick={props.toggleModal}>
            <i className='icon-arrow-left'></i> BACK
          </button>

          {dayObject.timeBlocks.length > 0 ? (
            <button
              className='btn btn-primary'
              onClick={() => {
                props.useForAllDays(dayObject.timeBlocks)
              }}>
              USE FOR ALL DAYS
            </button>
          ) : null}
        </div>
      </div>

      {dayObject.timeBlocks.length > 0
        ? dayObject.timeBlocks.map((timeBlock, index) => {
            return (
              <HoursItem
                key={index}
                timeBlock={timeBlock}
                timeBlockIndex={index}
                editingDay={props.editingDay}
                onInputChange={props.onInputChange}
                daysTimeBlocks={props.daysTimeBlocks}
                updateStateHours={props.updateStateHours}
                removeTimeblockHours={props.removeTimeblockHours}
              />
            )
          })
        : null}

      <button
        className='btn btn-primary'
        onClick={() => {
          props.createNewTimeblock(props.editingDay)
        }}>
        <i className='fa fa-plus'></i> &nbsp; Add a Time Block
      </button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/views/Components/HoursInput/HoursModal.js